export const QuillToolbarContainer = [
  [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
  [{ size: [] }],
  ['bold', 'italic', 'underline'],
  [{ 'align': '' }, { 'align': 'right' }, { 'align': 'center' }, { 'align': 'justify' }],
  ['blockquote'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  ['link', 'image', 'video'],
  ['clean'],
  ['code-block']
];

export const QuillFormats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'align',
  'link',
  'image',
  'video',
  'audio',
  'code-block',
];